import {TableDataTypes} from "../components/table/TableList";


export default function tableDataPatientcases() {
    let columnData = [
        {name: "id", type: TableDataTypes.hidden},
        {name: "Patient ID", type: TableDataTypes.title, size: 3, sortable: true},
        {name: "Created on", type: TableDataTypes.date, size: 3, sortable: true},
        {name: "Deadline", type: TableDataTypes.date, size: 3, sortable: true},
        {name: "Submissions", type: TableDataTypes.text, size: 2, sortable: true}
    ]
    let rowData = [
    ]

    return [columnData,rowData];
}